import { Field, FieldDescription, FieldLabel } from '@playbooks/ui/components/field';
import { Input } from '@playbooks/ui/components/input';

type MfaCodeFieldProps = {
	autoFocus?: boolean;
	description?: string;
	id?: string;
	label?: string;
	onChange: (value: string) => void;
	value: string;
};

const MfaCodeField = ({
	autoFocus = false,
	description,
	id = 'mfa-code',
	label = 'Six-digit code',
	onChange,
	value,
}: MfaCodeFieldProps) => {
	// Methods
	const onUpdate = event => onChange(event.target.value.replace(/\D/g, '').slice(0, 6));

	// Render
	return (
		<Field>
			<FieldLabel htmlFor={id}>{label}</FieldLabel>
			<Input
				autoFocus={autoFocus}
				id={id}
				value={value}
				type='text'
				inputMode='numeric'
				autoComplete='one-time-code'
				maxLength={6}
				placeholder='000000'
				className='font-mono tracking-[0.12em]'
				onChange={onUpdate}
			/>
			{description ? <FieldDescription>{description}</FieldDescription> : null}
		</Field>
	);
};

export { MfaCodeField };
export type { MfaCodeFieldProps };
